module.exports = __webpack_public_path__ + "static/media/smstocontrol3.7d7434ab.png";